import { jsx as e } from "react/jsx-runtime";
import { useTheme as z, Chip as s, Avatar as N, alpha as v } from "@mui/material";
import { D as a, b as r, j as F, e as g, C as j } from "../../../pointsGraph-DTJju-rA.js";
import { stripHtmlAndDecode as w } from "../../../helpers/strings.js";
import { prettyDate as L } from "../../../helpers/dates.js";
const q = ({ Category: f, Note: h, NoteDate: u, Updated: n, StaffID: p, StaffFirstname: y, StaffSurname: C, Attachments: m, EventTitle: c, EventDate: d, onClick: I, hideIcon: b = !1 }) => {
  const D = z(), T = w(h), { Colour: i, Caption: $, Priority: x } = f;
  let l = D.palette.primary.main;
  i && (l = i.startsWith("#") ? i : `#${i}`);
  let o = [];
  return p && o.push(/* @__PURE__ */ e(j, { size: "small", staffId: p, label: `${y} ${C}` }, "staffid")), x === 1 && o.push(/* @__PURE__ */ e(s, { size: "small", color: "error", label: "Important", icon: /* @__PURE__ */ e(a, { iconType: r.Priority }) }, "important")), d && c && o.push(/* @__PURE__ */ e(s, { size: "small", color: "info", label: `${c} ${d.toLocaleDateString()}`, icon: /* @__PURE__ */ e(a, { iconType: r.Calendar }) }, "event")), n && o.push(/* @__PURE__ */ e(s, { size: "small", variant: "outlined", label: `Updated: ${L(n)}`, icon: /* @__PURE__ */ e(a, { iconType: r.Calendar }) }, "updated")), m && m.forEach((t) => o.push(/* @__PURE__ */ e(F, { size: "small", fileName: t.FullName, fileId: t.FileID, extension: t.Ext, download: !0 }, t.FileID))), /* @__PURE__ */ e(
    g,
    {
      itemType: "lessonnote",
      title: $,
      description: T,
      avatar: b ? void 0 : /* @__PURE__ */ e(N, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: v(l, 0.15), color: l }, children: /* @__PURE__ */ e(a, { iconType: r.Note }) }),
      date: u,
      chips: o,
      onClick: I
    }
  );
};
export {
  q as NoteItem
};
//# sourceMappingURL=note.js.map
